import { render, staticRenderFns } from "./CopyMembersModal.vue?vue&type=template&id=27009146&"
import script from "./CopyMembersModal.vue?vue&type=script&lang=js&"
export * from "./CopyMembersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports